<ng-container>
  <ion-toolbar>
    <div class="toolbar-header moderate-background with-handle">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
      <h1>{{ title }}</h1>
      <div class="right"></div>
    </div>
  </ion-toolbar>
  <ion-content class="ion-padding">
    <div class="subtitle" [innerHTML]="subtitle"></div>

    <div *ngFor="let typology of typologies" class="typology-container">
      <img class="typology-picto" [src]="typology!.imageUrl" />
      <div class="typology-info">
        <div class="typology-title">{{ typology?.label }}</div>
        <div class="typology-description" [innerHTML]="typology?.description"></div>
      </div>
    </div>
  </ion-content>
</ng-container>
